import { LOADING_END, LOADING_START } from "../actions/ui.action";

export default (state, action) => {
  switch (action.type) {
    case LOADING_START: {
      return { ...state, loading: true };
    }
    case LOADING_END: {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
};
